import React, { Component } from 'react';
import HotelLocations from 'components/widgets/autocompletes/hotelDestinations';
import HotelOccupancy from 'components/widgets/hotelOccupancyLarge';
import ErrorHandler from 'libraries/errorHandler';
import RangePicker from 'components/widgets/rangePickerNights';
import ErrorTooltip from 'components/snippets/errorTooltip';
import moment from 'moment';
import CustomRangePickerNights from 'components/widgets/customRangePickerNights';
import Lang from 'libraries/Lang';
import HotelSearch from '../HotelSearch';
import LoadingModal from '../../../helpers/loadingModal';

class Hotel extends Component {
    constructor(props) {
        super(props);
        const agent = document.getElementById('AccountData').getAttribute('value');
        let agentData = null;
        if (agent !== '' && agent !== null) {
            agentData = JSON.parse(agent);
        }
        moment.locale(window.Locale);

        const stateValue = {
            selectedDestination: null,
            depDate: null,
            retDate: null,
            hotelType: 'G',
            numMonths: 2,
            occupancy: [{ adults: 2, children: 0, ages: [] }],
            occupancyOpen: false,
            shouldValidate: false,
            shouldValidateDepDate: false,
            shouldValidateRetDate: false,
            Traveltoken: props.Traveltoken,
            TravelRedirect: props.TravelRedirect,
            promoCode: '',
            eanData: null,
            destination: null,
            selectedHotel: null,
            selectedChain: null,
            errorList: {},

            hotelSection: false,
            activeTab: 'hotel',
            commonDateFormat: props.commonDateFormat,
            clearDepDateMsg: false,
            clearRetDateMsg: false,
            loadingModel: false,
            unicaId: null,
            language:'',
            agentData: agentData,
        };

        const rules = {
            'form.destination': (destination) => {
                let valid = true;

                if (destination === null || Object.keys(destination).length === 0) {
                    // valid = 'Select a destination';
                    valid = Lang.trans('engine_travelgenie.select_a_destination');
                }

                return valid;
            },
            'occupancy.childAge': (age, key, index) => {
                let valid = true;

                if (age === '') {
                    valid = `child ${index + 1} in room ${key + 1} needs an age`;
                }
                return valid;
            },
            'form.dates': (dates) => {
                let valid = true;
                if (dates.depDate === null || dates.retDate === null
                    || !moment(dates.depDate, 'MM/DD/YYYY', true).isValid()
                    || !moment(dates.retDate, 'MM/DD/YYYY', true).isValid()
                    || !(moment(dates.depDate, 'MM/DD/YYYY').isSameOrAfter(moment().format('MM/DD/YYYY')))
                    || !(moment(dates.retDate, 'MM/DD/YYYY').isSameOrAfter(moment().format('MM/DD/YYYY')))
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }

                if (!moment(dates.retDate).isAfter(dates.depDate)
                    && moment(dates.depDate, 'MM/DD/YYYY', true).isValid()
                    && moment(dates.retDate, 'MM/DD/YYYY', true).isValid()) {
                    // valid = 'Return date should be greater than departure date';
                    valid = Lang.trans('error.invalid_dates');
                }

                if (agentData!== undefined && agentData !== null && agentData !== '' && agentData.CallCenterLogin !== undefined && agentData.CallCenterLogin !== 'Y') {
                    if (moment(dates.depDate, "YYYY-MM-DD", true).isValid() && 
                    new Date(moment().add(2, 'days').format("YYYY-MM-DD")).getTime() > new Date(moment(dates.depDate).format("YYYY-MM-DD")).getTime()
                    ) {         
                        valid = Lang.trans('engine_travelgenie.hrs_error_for_departure_date');
                    }
                }

                if (valid == true) {
                    this.errorHandler.clear('form.departureDate');
                }

                return valid;
            },

            'form.departureDate': (depDate) => {
                let valid = true;

                if (depDate === null
                    || !moment(depDate, stateValue.commonDateFormat, true).isValid()
                    || !(moment(depDate, stateValue.commonDateFormat).isSameOrAfter(moment().format(stateValue.commonDateFormat)))
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }

                if (moment(depDate, stateValue.commonDateFormat, true).isValid()
                    && this.state.retDate != ''
                    && moment(this.state.retDate, stateValue.commonDateFormat, true).isValid()
                    && !moment(depDate, stateValue.commonDateFormat).isBefore(moment(this.state.retDate))) {
                    valid = Lang.trans('error.invalid_dates');
                }

                if (agentData!== undefined && agentData !== null && agentData !== '' && agentData.CallCenterLogin !== undefined && agentData.CallCenterLogin !== 'Y') {
                    if (moment(depDate, "YYYY-MM-DD", true).isValid() && 
                    new Date(moment().add(2, 'days').format("YYYY-MM-DD")).getTime() > new Date(moment(depDate).format("YYYY-MM-DD")).getTime()
                    ) {         
                        valid = Lang.trans('engine_travelgenie.hrs_error_for_departure_date');
                    }
                }

                // if (valid == true) {
                //     this.errorHandler.clear('form.retDate');
                //     this.setState({ clearRetDateMsg: true });
                // }

                if (valid == true) {
                    this.setState({ shouldValidateDepDate: false });
                } else {
                    this.setState({ shouldValidateDepDate: true });
                }

                return valid;
            },

            'form.returnDate': (retDate) => {
                let valid = true;
                if (retDate === null
                    || !moment(retDate, stateValue.commonDateFormat, true).isValid()
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }
                if (moment(retDate, stateValue.commonDateFormat, true).isValid() && this.state.depDate != '' && moment(this.state.depDate, stateValue.commonDateFormat, true).isValid() && !moment(retDate, 'DD-MMM-YYYY').isAfter(moment(this.state.depDate))) {
                    valid = Lang.trans('error.invalid_dates');
                }

                if (valid == true) {
                    this.setState({ shouldValidateRetDate: false });
                } else {
                    this.setState({ shouldValidateRetDate: true });
                }

                return valid;
            },
        };
        this.errorHandler = new ErrorHandler(rules);

        // const storage = localStorage.getItem('hotelEngine');
        // try {
        //     if (storage !== null && storage.length > 0) {
        //         Object.assign(stateValue, JSON.parse(storage));

        //         if (stateValue.depDate !== null) {
        //             stateValue.depDate = moment(stateValue.depDate);
        //             if (stateValue.depDate.isBefore(moment())) {
        //                 stateValue.depDate = moment();
        //             }
        //         }

        //         if (stateValue.retDate !== null) {
        //             stateValue.retDate = moment(stateValue.retDate);
        //             if (stateValue.retDate.isBefore(moment())) {
        //                 stateValue.retDate = moment().add(1, 'day');
        //             }
        //         }
        //     }
        // } catch (e) {
        //     // console.log(e);
        //     localStorage.removeItem('hotelEngine');
        // }

        this.state = stateValue;

        this.selectDestination = this.selectDestination.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.windowResize = this.windowResize.bind(this);
        this.onOccupancyChange = this.onOccupancyChange.bind(this);
        this.setOccupancy = this.setOccupancy.bind(this);
        this.handleOccupancyBlur = this.handleOccupancyBlur.bind(this);
        this.hotelChange = this.hotelChange.bind(this);
        this.submit = this.submit.bind(this);
        this.onCustomDatesChange = this.onCustomDatesChange.bind(this);
        this.onCustomNightChange = this.onCustomNightChange.bind(this);
        this.onPromoCodeChange = this.onPromoCodeChange.bind(this);
        this.handleHotelSection = this.handleHotelSection.bind(this);
        this.validateCustomDates = this.validateCustomDates.bind(this);
        this.clearHotelSelection = this.clearHotelSelection.bind(this);
    }

    handleHotelSection() {
        const { hotelSection } = this.state;
        let value = false;
        value = hotelSection !== true;
        this.setState({ hotelSection: value });
    }

    componentDidMount() {
        const app = document.getElementById('app');
        const { language } = app.dataset;
        this.setState({ language: language });
        window.addEventListener('resize', this.windowResize);
    }

    onPromoCodeChange(event) {
        this.setState({ promoCode: event.target.value });
    }

    clearHotelSelection() {
        this.setState({ 
            depDate: '',
            retDate: '',
            eanData: null,
            selectedHotel: null,
            selectedChain: null,
        });
    }

    handleOccupancyBlur(event) {
        let node = event.target;

        let within = false;

        while (node !== event.currentTarget) {
            node = node.parentNode;

            if (node.classList.contains('htl_popover')) {
                within = true;
                break;
            }
        }

        if (!within) {
            this.hideOccupancy();
        }
    }

    hotelChange(e) {
        if (e.target.value == 'net') {
            this.setState({ hotelType: 'N' });
        }

        if (e.target.value == 'gross') {
            this.setState({ hotelType: 'G' });
        }

        if (e.target.value == 'vacation') {
            const occupancyUpdate = [{ adults: 2, children: 0, ages: [] }];
            this.setState({ hotelType: 'M', occupancy: occupancyUpdate });
        }
    }

    onDatesChange(depDate, retDate) {
        const { shouldValidate, shouldValidateDepDate, shouldValidateRetDate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.dates', { depDate, retDate });
            this.errorHandler.clear('form.dates');
        }
        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        } else {
            this.errorHandler.checkRule('form.departureDate', depDate);
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        } else {
            this.errorHandler.checkRule('form.returnDate', retDate);
        }
        this.setState({ depDate, retDate });
    }

    validateCustomDates(name, depDate) {
        const {
            shouldValidate, commonDateFormat, shouldValidateRetDate, shouldValidateDepDate,
        } = this.state;
        this.errorHandler.clear('form.dates');

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        }

        if (name == 'depDate' && depDate != '') {
            this.errorHandler.checkRule('form.departureDate', depDate);
        }
        if (depDate != '' && name == 'retDate') {
            this.errorHandler.checkRule('form.returnDate', depDate);
        }

        this.setState({ shouldValidateCustomDate: true });
    }

    onCustomDatesChange(name, depDate) {
        const dateMonth = depDate.replace(/[0-9]/g, '').toLowerCase();
        let updatedDate = depDate;
        const { language } = app.dataset;

        if (language == 'fr') {
            let lowerCaseDate = depDate.toLowerCase();
            if (dateMonth == 'jan') {
                updatedDate =  lowerCaseDate.replace('jan', 'janv');
            } else if (dateMonth == 'fev') {
                updatedDate =  lowerCaseDate.replace('fev', 'févr.');
            } else if (dateMonth == 'mar') {
                updatedDate =  lowerCaseDate.replace('mar', 'mars');
            } else if (dateMonth == 'avr') {
                updatedDate =  lowerCaseDate.replace('avr', 'avr.');
            } else if (dateMonth == 'mai') {
                updatedDate =  lowerCaseDate.replace('mai', 'mai');
            } else if (dateMonth == 'jun') {
                updatedDate =  lowerCaseDate.replace('jun', 'juin');
            } else if (dateMonth == 'jul') {
                updatedDate =  lowerCaseDate.replace('jul', 'juil');
            }  else if (dateMonth == 'aou') {
                updatedDate =  lowerCaseDate.replace('aou', 'août');
            }  else if (dateMonth == 'sep') {
                updatedDate =  lowerCaseDate.replace('sep', 'sept');
            }  else if (dateMonth == 'oct') {
                updatedDate =  lowerCaseDate.replace('oct', 'oct.');
            }  else if (dateMonth == 'nov') {
                updatedDate =  lowerCaseDate.replace('nov', 'nov.');
            }  else if (dateMonth == 'dec') {
                updatedDate =  lowerCaseDate.replace('dec', 'déc.');
            }  
        }

        const {
            shouldValidate, commonDateFormat, shouldValidateDepDate, shouldValidateRetDate,
        } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.dates', { updatedDate });
            this.errorHandler.clear('form.dates');
        }
        // alert(moment(depDate, 'MM/DD/YYYY', true).isValid()+"##")
        updatedDate = moment(updatedDate, commonDateFormat, true).isValid() ? moment(updatedDate, 'DD-MMM-YYYY') : updatedDate;

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        }

        this.setState({ [name]: updatedDate }, () => {
            const { depDate, retDate } = this.state;
            this.errorHandler.checkRule('form.dates', { depDate, retDate });
        });
    }

    onCustomNightChange(days) {
        const { shouldValidate, shouldValidateDepDate, shouldValidateRetDate } = this.state;
        const { depDate } = this.state;

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        }
        let retDate = '';
        if (days != '' && days != 0) {
            retDate = moment(depDate, 'MM/DD/YYYY').add(days, 'days');
        } else {
            retDate = '';
        }

        this.setState({
            retDate,
        }, () => {
            if (depDate != '') {
                this.errorHandler.checkRule('form.departureDate', depDate);
            }
            if (retDate != '') {
                this.errorHandler.checkRule('form.returnDate', retDate);
            }
            if (depDate != '' && retDate != '') {
                this.errorHandler.checkRule('form.dates', { depDate, retDate });
            }
        });

        //  this.setState({ retDate : retDate });
    }

    onOccupancyChange(occupancy, paramter) {
        const [room, field, index] = paramter.split('-');
        const { occupancy: currentOccupancy } = this.state;

        if (field === 'children' && currentOccupancy[parseInt(room, 10)].children > occupancy[parseInt(room, 10)].children) {
            for (let i = currentOccupancy[parseInt(room, 10)].children; i > occupancy[parseInt(room, 10)].children; i--) {
                this.errorHandler.clear(`occupancy-${room}.childAge-${i - 1}`);
            }
        }

        if (field === 'rooms' && currentOccupancy.length > occupancy.length) {
            for (let i = currentOccupancy.length, { length } = occupancy; i > length; i--) {
                this.errorHandler.clear(`occupancy-${i - 1}`);
            }
        }

        const { shouldValidate } = this.state;
        if (shouldValidate && field === 'childAge') {
            this.errorHandler.checkRule(`occupancy-${room}.childAge-${index}`, occupancy[room].ages[index]);
        }
        this.setState({ occupancy });
    }

    setOccupancy(occupancyOpen) {
        if (occupancyOpen) {
            this.showOccupancy();
        } else {
            this.hideOccupancy();
        }
    }

    hideOccupancy() {
        const app = document.getElementById('page');
        app.removeEventListener('click', this.handleOccupancyBlur);

        this.setState({ occupancyOpen: false });
    }

    showOccupancy() {
        const app = document.getElementById('page');
        app.addEventListener('click', this.handleOccupancyBlur);

        this.setState({ occupancyOpen: true });
    }

    selectDestination(selectedDestination) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.destination', selectedDestination);
        }

        console.log(selectedDestination)
        console.log("###")
        this.setSearchParameter('selectedHotel', null);
        if (selectedDestination !== null && selectedDestination.category !== undefined && selectedDestination.category == 'hotel') {
            let unicaId = selectedDestination.unicaId
            this.setState({ unicaId })
            const eanData = this.getHotelDetail(unicaId, 'H');
            eanData.then((data) => {
                this.setSearchParameter('eanData', data);
            });
            this.setSearchParameter('selectedHotel', selectedDestination);
        } else {
            this.setSearchParameter('eanData', null);
            this.setSearchParameter('selectedHotel', null);
        }
        this.setState({ selectedDestination: selectedDestination, selectedChain: null });
    }

    getHotelDetail(hotelId, type) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.open('GET', `/api/autocompletes/hotel-detail/${hotelId}/${type}`);

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    const data = JSON.parse(xhr.response);
                    resolve(data);
                } else {
                    console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
                }
            };
            xhr.onerror = () => {
                console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            };
            xhr.send();
        });
    }


    windowResize() {
        if (this.resizeTimer !== null) clearTimeout(this.resizeTimer);

        this.resizeTimer = setTimeout(() => { this.setState({ numMonths: window.innerWidth > 767 ? 2 : 1 }); }, 250);
    }

    setSearchParameter = (field, value) => {
        this.setState((prevState) => {
            const searchBundleArray = Object.assign({}, prevState); // creating copy of state variable jsonper
            searchBundleArray[field] = value; // update the name property, assign a new value
            return searchBundleArray; // return new object jsonper object
        });
    }

    submit(event) {
        const {
            occupancy,
            selectedDestination,
            hotelType,
            depDate,
            retDate,
            Traveltoken,
            TravelRedirect,
            promoCode,
            selectedHotel,
            selectedChain,
            eanData,
            language,
        } = this.state;

        this.errorHandler.checkRule('form.destination', selectedDestination);
        this.errorHandler.checkRule('form.dates', { depDate, retDate });
        occupancy.forEach((room, key) => {
            room.ages.forEach((age, index) => {
                this.errorHandler.checkRule(`occupancy-${key}.childAge-${index}`, occupancy[key].ages[index]);
            });
        });

        const errors = this.errorHandler.getErrors();

        if (Object.keys(errors).length > 0) {
            event.preventDefault();
            this.setState({ shouldValidate: true });
        } else {


            this.setState({ loadingModel: true });

            const agent = document.getElementById('AccountData').getAttribute('value');
            let agentData = null;
            if (agent !== '' && agent !== null) {
                agentData = JSON.parse(agent);
            }
            event.preventDefault();

            const bundles = {};
            const params = {};

            params.occupancy = occupancy;
            params.depDate = depDate !== null ? depDate.format('YYYY-MM-DD') : '',
                params.retDate = retDate !== null ? retDate.format('YYYY-MM-DD') : '',
                params.destination = Object.assign({}, selectedDestination);

                if(params.destination.text && params.destination.text !== undefined && params.destination.text !== null){
                    params.destination.text = encodeURIComponent(params.destination.text);
                }
                if(params.destination.city && params.destination.city !== undefined && params.destination.city !== null){
                    params.destination.city = encodeURIComponent(params.destination.city);
                }
        
            if (hotelType == 'M') {
                bundles.searchType = 'monaker';
                params.selectedProducts = 'M';
            } else {
                bundles.searchType = 'hotel';
                params.checkInDate = depDate !== null ? depDate.format('YYYY-MM-DD') : '',
                params.checkOutDate = retDate !== null ? retDate.format('YYYY-MM-DD') : '',
                params.selectedProducts = 'H';
                params.actualSelectedProducts = 'H';
                params.hotelType = hotelType;
                bundles.selectedHotelType = hotelType;

                const selectedSearchHotel = Object.assign({}, selectedHotel);
                if (selectedSearchHotel !== undefined && selectedSearchHotel !== null) {
                    if (selectedSearchHotel.text !== undefined && selectedSearchHotel.text !== null) {
                        selectedSearchHotel.text = encodeURIComponent(selectedSearchHotel.text);
                    }
                    if (selectedSearchHotel.text2 !== undefined && selectedSearchHotel.text2 !== null) {
                        selectedSearchHotel.text2 = encodeURIComponent(selectedSearchHotel.text2);
                    }
                    if (selectedSearchHotel.value !== undefined && selectedSearchHotel.value !== null) {
                        selectedSearchHotel.value = encodeURIComponent(selectedSearchHotel.value);
                    }
                }

                params.selectedHotel = selectedSearchHotel;
                params.selectedChain = selectedChain;
                params.chainName = (selectedChain != null && selectedChain.value) ? selectedChain.value : '', 
                params.eanHotelIds = eanData?.eanHotelIds != null ? eanData.eanHotelIds : [];
                params.pricelineHotelIds = eanData?.pricelineHotelIds != null ? eanData.pricelineHotelIds : [];
                params.tbiHotelIds = eanData?.tbiHotelIds != null ? eanData.tbiHotelIds : [];
                params.isAdvance = ((eanData?.eanHotelIds != null) || (eanData?.pricelineHotelIds != null) || (eanData?.tbiHotelIds != null)) ?  true : false;
            }

            bundles.bundles = [{ ...params }];

            // bundles.refundable = "1";
            bundles.lang = window.Locale;
            if (params.selectedProducts == 'H') {
                bundles.currency = 'USD';
            }
            bundles.affiliate = 'redtag';
            bundles.promoCode = promoCode;

            let chainId = '';
            let agentId = '';
            let agencyId = '';
            let organizationId = '';
            let agentLogin = '';
            let agentFirstName = '';
            let agentLastName = '';
            let newBooking = null;

            if (agentData !== '' && agentData !== null) {
                chainId = typeof agentData.Chain !== 'undefined' && agentData.Chain !== null && agentData.Chain !== '' ? agentData.Chain.code : '';
                agencyId = typeof agentData.Agency !== 'undefined' && agentData.Agency.phone !== null && agentData.Agency.phone !== '' ? agentData.Agency.phone : '';
                // agentId = typeof agentData.TtsId !== 'undefined' && agentData.TtsId !== null && agentData.TtsId !== '' ? agentData.TtsId : '';
                agentId = typeof agentData.AgentId !== 'undefined' && agentData.AgentId !== null && agentData.AgentId !== '' ? agentData.AgentId : '';
                organizationId = typeof agentData.OrganizationId !== 'undefined' && agentData.OrganizationId !== null && agentData.OrganizationId !== '' ? agentData.OrganizationId : '';
                agentLogin = typeof agentData.Names.username !== 'undefined' && agentData.Names.username !== null && agentData.Names.username !== '' ? agentData.Names.username : '';
                agentFirstName = typeof agentData.Names.first !== 'undefined' && agentData.Names.first !== null && agentData.Names.first !== '' ? agentData.Names.first : '';
                agentLastName = typeof agentData.Names.last !== 'undefined' && agentData.Names.last !== null && agentData.Names.last !== '' ? agentData.Names.last : '';
                newBooking = (agentData.newBooking && agentData.newBooking == true) ? true : null;
            }
            bundles.chainId = chainId;
            bundles.agentId = agentId;
            bundles.agencyId = agencyId;
            bundles.organizationId = organizationId;
            bundles.agentLogin = agentLogin;
            bundles.agentFirstName = agentFirstName;
            bundles.agentLastName = agentLastName;
            bundles.localeLang = language;

            if (agentData.CallCenterLogin === 'Y') {
                bundles.rezAgentUserId = agentData.CallCenterUserName;
            }

            const queryString = JSON.stringify(bundles);

            const encodeUrl = encodeURI(queryString);
            const url = `${TravelRedirect}/create?t=${Traveltoken}&localeLang=${language}&request=${encodeUrl}${newBooking == true ? '&newBooking=true' : ''}`;
            window.location.href = url;

            const storage = {
                selectedDestination,
                depDate,
                retDate,
                occupancy,
                hotelType,
                promoCode,
            };

            localStorage.setItem('hotelEngine', JSON.stringify(storage));

            // const url = TravelRedirect+"/?t=" + Traveltoken;
            // window.location.href = url;
        }
    }

    render() {
        const {
            selectedDestination,
            depDate,
            retDate,
            occupancy,
            occupancyOpen,
            numMonths,
            noOfNights,
            TravelRedirect,
            hotelType,
            promoCode,
            Traveltoken,
            hotelSection,
            activeTab,
            commonDateFormat,
            loadingModel,
            shouldValidateDepDate,
            shouldValidateRetDate,
            language,
            agentData
        } = this.state;

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        }

        const isDepDatevalid = moment(depDate, commonDateFormat, true).isValid();
        const isRetDatevalid = moment(retDate, commonDateFormat, true).isValid();

        const errors = this.errorHandler.getErrors();

        const request = {
            occupancy,
            depDate: (depDate !== null && moment(depDate, 'MM/DD/YYYY', true).isValid()) ? depDate.format('YYYY-MM-DD') : '',
            retDate: (retDate !== null && moment(retDate, 'MM/DD/YYYY', true).isValid()) ? retDate.format('YYYY-MM-DD') : '',
            destination: selectedDestination,
            selectedProducts: 'H',
            lang: 'en',
        };
        const agentAccount = document.getElementById('AccountData').getAttribute('value');
        let agentDetail = null;
        if (agentAccount !== '' && agentAccount !== null) {
            agentDetail = JSON.parse(agentAccount);
        }

        let minDate = 0;
        if(agentData!== undefined && agentData !== null && agentData !== '' && agentData.CallCenterLogin !== undefined && agentData.CallCenterLogin !== 'Y'){
            minDate = 2;
        }

        return (
            <>
                <LoadingModal isLoading={loadingModel} />
                <form className="search-hotel hotel-flight-horizontal-search" method="POST" onSubmit={this.submit}>
                    <input type="hidden" name="request" value={JSON.stringify(request)} />
                    <div className="row gutter-10 mb-1">
                        <div className="col-6 text-left">
                            <div className="styled-radio black-text mb-2">
                                <input type="radio" id="radio-gross" name="trip" value="gross" checked={hotelType == 'G'} onChange={this.hotelChange} />
                                <label className="text-label" htmlFor="radio-gross">
                                    <span>{Lang.trans('engine_hotels.gross')}</span>
                                </label>
                            </div>
                            <div className="styled-radio black-text mb-2">
                                <input type="radio" id="radio-net" name="trip" value="net" checked={hotelType == 'N'} onChange={this.hotelChange} />
                                <label className="text-label" htmlFor="radio-net">
                                    <span>{Lang.trans('engine_hotels.net')}</span>
                                </label>
                            </div>
                            {/* <div className="styled-radio black-text">
                                <input type="radio" id="radio-vacation" name="trip" value="vacation" checked={hotelType == 'M'} onChange={this.hotelChange} />
                                <label className="text-label" htmlFor="radio-vacation">
                                    <span>{Lang.trans('engine_hotels.vacation_rental')}</span>
                                </label>
                            </div> */}
                        </div>
                        <div className="col-6 text-right">
                            <a href={`${TravelRedirect}/multi-destination?t=${Traveltoken}&localeLang=${language}&from=h${agentDetail !== null && agentDetail.newBooking && agentDetail.newBooking == true ? '&newBooking=true' : ''}`} type="" className="col-6 col-md-6 text-underline">
                                <span className="">{Lang.trans('engine.multipleDestination')}</span>
                            </a>
                        </div>
                    </div>

                    <div className="row gutter-10 mb-md-2">
                        <div className="col-12 col-md-12 col-lg-12 col-xl-4 departing-from">
                            <div className="element-container">
                                <label className="text-label" htmlFor="hotel_destination">{Lang.trans('engine.destination')} {Lang.trans('engine.or')} {Lang.trans('engine.hotel')}</label>
                                <div className="element-wrapper">
                                    <HotelLocations
                                        id="hotel_destination"
                                        placeholder={Lang.trans('engine.city_hotel_name')}
                                        onSelect={this.selectDestination}
                                        value={selectedDestination}
                                    />
                                    {errors.form && errors.form.destination && (
                                        <ErrorTooltip error={{ message: errors.form.destination, id: 'destination' }} />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-8 col-xl-5 duration">
                            <div className="element-container range-picker-container">
                                {/* <RangePicker
                                startDateId="htl_departureDate"
                                endDateId="htl_returnDate"
                                onDatesChange={this.onDatesChange}
                                minDate={2}
                                startDatePlaceholderText="Start Date"
                                endDatePlaceholderText="End Date"
                                startDate={depDate}
                                endDate={retDate}
                                numberOfMonths={numMonths}
                            /> */}
                                <CustomRangePickerNights
                                    startDateId="dyn_departureDate"
                                    endDateId="dyn_returnDate"
                                    onDatesChange={this.onDatesChange}
                                    onCustomDatesChange={this.onCustomDatesChange}
                                    onCustomNightChange={this.onCustomNightChange}
                                    minDate={minDate}
                                    noOfNights={noOfNights}
                                    startDatePlaceholderText={Lang.trans('engine.date_format')}
                                    endDatePlaceholderText={Lang.trans('engine.date_format')}
                                    startDate={depDate}
                                    endDate={retDate}
                                    isDepDatevalid={isDepDatevalid}
                                    isRetDatevalid={isRetDatevalid}
                                    activeTab="hotel"
                                    dateFormat={commonDateFormat}
                                    // calendarInfo={calendarInfo}
                                    validateCustomDates={this.validateCustomDates}
                                />
                                {errors.form && errors.form.departureDate && (
                                    <ErrorTooltip error={{ message: errors.form.departureDate, id: 'departureDate' }} />
                                )}
                                {errors.form && errors.form.returnDate && (
                                    <ErrorTooltip error={{ message: errors.form.returnDate, id: 'returnDate' }} />
                                )}
                                {errors.form && errors.form.dates && (
                                    <ErrorTooltip error={{ message: errors.form.dates, id: 'dates' }} />
                                )}
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-4 col-xl-3 room-guest">
                            <div className="element-container mb-lg-0">
                                <HotelOccupancy
                                    visible={occupancyOpen}
                                    occupancy={occupancy}
                                    errors={errors}
                                    validateField={() => { }}
                                    onChange={this.onOccupancyChange}
                                    onVisibilityChange={this.setOccupancy}
                                    hotelType={hotelType}
                                />
                            </div>
                        </div>
                    </div>

                    {hotelType != 'M'
                        ? (
                            <>
                                <div className="mb-2 d-flex justify-content-between">
                                    <a onClick={this.handleHotelSection} type=""  style={{ cursor: 'pointer' }}>
                                        <span className="mr-2 text-underline primary-color">{Lang.trans('engine.additionalHotelFilter')}</span>
                                        <svg className="icon-sm primary-color">
                                            <use xmlns="http://www.w3.org/2000/svg" xlinkHref={`/img/icons/icon-defs.svg#${hotelSection ? 'icon-chevron-up' : 'icon-chevron-down-lihgt'}`} />
                                        </svg>
                                    </a>
                                    {hotelSection && (
                                        <a onClick={this.clearHotelSelection} type="" role="button">
                                            <span className="mr-2 primary-color text-underline">{Lang.trans('engine.clear')}</span>
                                        </a>
                                    )}
                                </div>
                                {hotelSection && (
                                    <>
                                        <HotelSearch hotelData={this.state} errorHandler={this.errorHandler} errors={errors} setSearchParameter={this.setSearchParameter} />
                                       
                                    </>
                                )}
                            </>
                        )
                        : null}

                    <div className="row gutter-0 border-top pt-2 align-items-center justify-content-center">
                        <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-5 my-2">
                        <div className="row gutter-20">
                            {/* <div className="col-6">
                                    <div className="element-container mb-0">
                                        <div className="date-picker-btn position-relative">
                                            <span className="text-label">{Lang.trans('engine.promoCode')}</span>
                                            <input
                                                className="w-100 h-100 py-0 pl-0 pb-1 pr-3"
                                                placeholder={Lang.trans('engine.enter_code')} 
                                                name="promoCode"
                                                onChange={this.onPromoCodeChange}
                                                // readOnly={!!((this.props.promoCode !== null))}
                                                value={promoCode}
                                            />
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-12 text-center mb-2 mb-lg-0 mt-3">
                                    <button type="submit" className="btn btn-primary btn-lg px-5 font-weight-600">
                                        <span className="">{Lang.trans('buttons.search')}</span>
                                    </button>
                                </div>
                                <div className="col-3"></div>
                            </div>
                            {/* <input name="" id="" className="col-12 col-sm-6 bg-white font-weight-500 py-3 border" placeholder={Lang.trans('engine.promoCode')} value={promoCode} onChange={this.onPromoCodeChange} /> */}
                           
                           
                        </div>
                        
                    </div>
                </form>
            </>
        );
    }
}

export default Hotel;
